import { constants, Styles } from '@/styles';

export const styles: Styles = {
  display: 'flex',
  flexDirection: 'row',
  justifyItems: 'center',
  alignItems: 'center',
  maxWidth: 250,

  '.control': {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
  },

  '.divider': {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
    padding: constants.offset.small,
  },
};
